module.exports = __webpack_public_path__ + "img/3.ad867b1a.jpg";